import { useEffect, useState, useRef } from 'react';
import { LandingHeader } from './LandingHeader';
import { SimpleFooter } from '../footer/Footer';
import { useAuthToken } from '../../hooks/useAuthToken';
import { useUserPlan } from '../../hooks/useUserPlan';
import { PLAN_TYPE_EAN_STUDENT_TACHER_COLLABORATOR } from '../../assets/constants';
import { AcceptDialog } from '../controls/UIControls';
const landingImages = require.context('../../assets/images', true);
export const LandingPage = () => {
  const [eanuserDialog, setEanuserDialog] = useState(false);
  const { authToken, isLogged } = useAuthToken();
  const { checkUserPlan } = useUserPlan();
  const setEanActivePlan = useState(false);
  const [, setIframeHeight] = useState('200');
  const iframeRef = useRef(null);
  const ajustarAlturaIframe = () => {
    if (iframeRef.current) {
      const iframeWidth = iframeRef.current.offsetWidth;
      const aspectRatio = 9 / 16;
      const newHeight = Math.floor(iframeWidth * aspectRatio);
      setIframeHeight(`${newHeight}px`);
    }
  };
  useEffect(() => {
    ajustarAlturaIframe();
    const handleResize = () => {
      ajustarAlturaIframe();
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (isLogged()) {
      checkUserPlan(authToken).then((hasPlan) => {
        if (hasPlan && hasPlan.planType == PLAN_TYPE_EAN_STUDENT_TACHER_COLLABORATOR) {
          setEanActivePlan(true);
        }
      });
    }
  }, []);

  window.addEventListener('scroll', function () {
    if (this.window.scrollY > 100) {
      const elements = this.document.getElementsByClassName('landing__whatsapp-button-static');
      for (let i = 0; i < elements.length; i++) {
        const element = elements[i];
        element.classList.add('landing__whatsapp-button');
        element.classList.remove('landing__whatsapp-button-static');
      }
    }
  });
  return (
    <>
      <LandingHeader />
      <AcceptDialog
        open={eanuserDialog}
        message="Ya disfrutas de un plan B2B."
        style="info"
        afterClose={() => setEanuserDialog(false)}
      ></AcceptDialog>
      <div className="landing__container-eres-comunidad-eanista mt-5">
        <div className="container mt-5">
          <div className="row justify-content-center align-items-center">
            <div className="col-12">
              <img
                src={landingImages(`./banner-potenciando-talento.png`)}
                alt="Hero"
                className="img-fluid"
                style={{
                  width: '100%',
                  height: 'auto',
                  display: 'block',
                  margin: '0 auto',
                }}
              />
            </div>
            <div className="col-12">
              <div className="row">
                <div className="col-12 landing__text-eres-comunidad-eanista">
                  <span className="landing__text-color-green mt-2">
                    🚀 Potencia tu talento, transforma tu impacto
                  </span>
                </div>
              </div>
              <div className="row my-4">
                <div className="col-12 landing__paragraph-text">
                  <p className="landing__text-color-dark-green">
                    En la Universidad Ean, creemos firmemente que el aprendizaje continuo es
                    esencial para la evolución profesional y el fortalecimiento de habilidades que
                    te mantendrán a la vanguardia.
                  </p>
                  <p className="landing__text-color-dark-green">
                    Esta plataforma ha sido diseñada especialmente para ti, con contenidos que
                    impulsan tu desarrollo, amplían tus habilidades y te inspiran a liderar con
                    propósito.
                  </p>
                  <p className="landing__text-color-dark-green">
                    💡 Aquí podrás explorar experiencias de formación flexibles, dinámicas y
                    alineadas con los desafíos del mundo actual.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SimpleFooter />
    </>
  );
};
